import React from 'react';

import { rgba, scssVariables as variables, userFullName } from 'src/helpers';
import { MCButton, MCText, View } from 'src/components/basic';
import { tabs } from 'src/components/mobile/utils';
import { MAX_WIDTH, remCss, remFontCss } from '../utils';
import HospitalAvatar from 'src/assets/images/clinic-profile.png';

export const Header = ({ clinic, activeTab, medium, onActiveTab }) => {
  return (
    <View
      style={{
        height: remCss(medium ? 190 : 220)
      }}
    >
      <View
        style={{
          height: remCss(medium ? 100 : 120),
          backgroundColor: 'white'
        }}
      >
        <View
          style={{
            flexDirection: 'row',
            paddingHorizontal: remCss(50),
            marginTop: remCss(medium ? 30 : 50)
          }}
        >
          <View
            style={{
              marginHorizontal: 'auto',
              maxWidth: MAX_WIDTH,
              flex: 1,
              flexDirection: 'row',
              alignItems: 'center',
              gap: remCss(30)
            }}
          >
            <img
              style={{
                width: remCss(140 - 4),
                height: remCss(140 - 4),
                borderRadius: remCss(20),
                borderColor: variables['colors-mc-border2'],
                backgroundColor: 'white',
                objectFit: 'cover',
                borderWidth: 2,
                borderStyle: 'solid'
              }}
              src={clinic.avatar || HospitalAvatar}
            />
            <View style={{ gap: remCss(10), flex: 1 }}>
              <MCText
                heading
                label={userFullName(clinic)}
                size={25}
                remFontCss={remFontCss}
                weight={900}
              />
              <MCText
                heading
                label={clinic.description}
                size={20}
                remFontCss={remFontCss}
                weight={400}
                numberOfLines={1}
              />
            </View>
            <View
              style={{
                flexDirection: 'row',
                justifyContent: 'space-between',
                backgroundColor: 'white',
                paddingHorizontal: remCss(15),
                paddingVertical: remCss(13),
                borderRadius: remCss(10),
                borderColor: variables['colors-mc-border2'],
                borderWidth: 0.5,
                borderStyle: 'solid'
              }}
            >
              {tabs.map((tab) => {
                const active = activeTab === tab.id;
                return (
                  <MCButton
                    type={'button'}
                    key={tab.id}
                    radius
                    label={tab.label}
                    medium={!medium}
                    small={medium}
                    style={{
                      backgroundColor: active ? rgba(variables['colors-mc-primary'], 0.2) : 'white',
                      color: active
                        ? variables['colors-mc-primary']
                        : variables['colors-mc-text-primary'],
                      fontSize: remFontCss(!medium ? 25 : 18)
                    }}
                    onClick={() => {
                      onActiveTab(tab.id);
                    }}
                  />
                );
              })}
            </View>
          </View>
        </View>
      </View>
    </View>
  );
};
